<template>
	<v-card rounded elevation='10'>
		<v-sheet dark color="#16528E">
			<v-card-text class="font-weight-light text-uppercase">
				<span
					class="display-1 font-weight-light text-uppercase"
					style="opacity: 0.8"
					v-text="item.label"
				/>
			</v-card-text>
		</v-sheet>
		<v-card-text class="body-1" v-html="item.email" />
	</v-card>
</template>

<script>
export default {
	name: 'ContactItem-n',
	props: {
		item: Object
	}
}
</script>

<style lang="scss" scoped>
</style>